/** Cell state helpers for the Daily Pay Sheet grid. */
export type CellState = 'PAYABLE' | 'NOT_PAYABLE' | 'UNSET';

/** Saved values — solid fill. */
export const CELL_STYLE: Record<CellState, string> = {
  PAYABLE:
    'bg-theme-success-500/20 border-theme-success-500 text-theme-success-500',
  NOT_PAYABLE:
    'bg-theme-error-500/10 border-theme-error-500 text-theme-error-500',
  UNSET: 'bg-theme-slate-900 border-theme-gray-700 text-white/30',
};

/**
 * Edited but not saved yet — darker fill + dashed border, so it is obvious
 * which cells are still pending against the ones already stored.
 */
export const CELL_STYLE_DIRTY: Record<CellState, string> = {
  PAYABLE:
    'bg-theme-success-500/5 border-dashed border-theme-success-500/60 text-theme-success-500/70',
  NOT_PAYABLE:
    'bg-theme-error-500/5 border-dashed border-theme-error-500/60 text-theme-error-500/70',
  UNSET: 'bg-theme-slate-900 border-dashed border-theme-gray-700 text-white/30',
};

export const CELL_LABEL: Record<CellState, string> = {
  PAYABLE: '✓',
  NOT_PAYABLE: '✕',
  UNSET: '–',
};

export const toCellState = (value: boolean | null | undefined): CellState =>
  value === true ? 'PAYABLE' : value === false ? 'NOT_PAYABLE' : 'UNSET';

/** Clicking cycles the two decided states; an undecided cell becomes payable. */
export const nextCellState = (state: CellState): boolean => state !== 'PAYABLE';
